<div *ngIf="!booking">
  <app-loading-spinner></app-loading-spinner>
</div>
<div *ngIf="booking" class="main-wrap">
  <h3>
      Booking
  </h3>
  <div class="booking-wrap">
    <div class="tabs-wrap">
      <div (click)="activateTab(1)" [ngClass]="{'selected-box': viewMode == 1, 'unselected-box': viewMode != 1}">
        <div class="tab">
          Booking
        </div>
      </div>
      <div (click)="activateTab(2)" 
      [ngClass]="{'selected-box': viewMode == 2, 'unselected-box': viewMode != 2}"
      *ngIf="userService.hasAnyRole(['admin', 'editor'])">
        <div class="tab">
          Picture
        </div>
      </div>
      <div (click)="activateTab(3)" [ngClass]="{'selected-box': viewMode == 3, 'unselected-box': viewMode != 3}" *ngIf="bookingService.hasVademecum">
        <div class="tab">
          Doc
        </div>
      </div>
      <div (click)="activateTab(4)" [ngClass]="{'selected-box': viewMode == 4, 'unselected-box': viewMode != 4}" *ngIf="bookingService.hasVademecum">
          <div class="tab">
            Medical
          </div>
        </div>
        <div (click)="activateTab(5)" [ngClass]="{'selected-box': viewMode == 5, 'unselected-box': viewMode != 5}" *ngIf="bookingService.hasVademecum">
            <div class="tab">
              School
            </div>
          </div>
    </div>
    <div class="edit-zone">
      <div *ngIf="viewMode == 1">
        <app-edit-booking-detail *ngIf="userService.hasAnyRole(['admin', 'editor'])"></app-edit-booking-detail>
        <app-view-booking-detail *ngIf="userService.hasRole('bruges_viewer') && userService.isNotAnyOf(['admin', 'editor'])"></app-view-booking-detail>
      </div>
      <div *ngIf="viewMode == 2">
        <div class="file-edit">
          <app-edit-booking-picture></app-edit-booking-picture>
        </div>
      </div>
         <div *ngIf="viewMode == 3">
        <div class="doc-edit">
          <app-edit-booking-vademecum [booking]="booking"></app-edit-booking-vademecum>
        </div>
      </div>
      <div *ngIf="viewMode == 4">
        <div>
          <app-edit-medical-info></app-edit-medical-info>
        </div>
      </div>
      <div *ngIf="viewMode == 5">
          <div>
            <app-edit-school-info></app-edit-school-info>
          </div>
        </div>
    </div>
  </div>

</div>
